module.exports = "<iframe frameborder=\"0\" class=\"maximize iframe-frame\" ng-attr-src=\"{{$ctrl.src | trusted}}\"></iframe>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/iframe.component.html
// module id = 952
// module chunks = 0